module.exports = __webpack_public_path__ + "static/img/Bachelor_010791.3efd851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010791.jpg
// module id = 247
// module chunks = 0